import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MyAccountComponent } from './account/my-account/my-account.component';
import { PostLoginLayoutComponent } from './layout/postLogin-layout.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { CallbackComponent } from './layout/callback/callback.component';
import { SimulatorBookingAuthGuard } from './simulator-booking/simulator-booking-authguard';
import { PostLoginSimBookLayoutComponent } from './layout/simbook/postLogin-simbook-layout.component';
import { PostLoginOutingLayoutComponent } from './layout/outing/postLogin-outing-layout.component';
import { SimbookDashboardComponent } from './simulator-booking/simbook-dashboard/simbook-dashboard.component';
import { BookingWidgetComponent } from './widget/booking-widget/booking-widget.component';
import { DigitalWaiverWidgetComponent } from './widget/digital-waiver-widget/digital-waiver-widget.component';
import { SignUpAuthGuard } from './core/sing-up-auth-guard';
import { SignUpShellComponent } from './layout/sign-up/shell/sign-up-shell.component';
import { BookingMembershipWidgetComponent } from './widget/booking-membership-widget/booking-membership-widget.component';
import { MembershipCustomerWidgetComponent } from './widget/membership-customer-widget/membership-customer-widget.component';
import { RegistrationWidgetComponent } from './widget/registration-widget/registration-widget.component';
import { PaymentSuccessFailureComponent } from './shared/ui/payment-success-failure/payment-success-failure.component';

const routes: Routes = [
  {
    path: '',
    component: PostLoginLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'signup',
    component: SignUpShellComponent,
    canActivate: [SignUpAuthGuard]
  },
  {
    path: 'outing-management',
    component: PostLoginOutingLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'my-account/:id', component: MyAccountComponent },
      { path: 'my-account/:id/edit', redirectTo: 'my-account/:id', pathMatch: 'full' },
      {
        path: 'outing',
        loadChildren: () => import('./outing/outing.module').then(m => m.OutingModule),
      },
      {
        path: 'administration',
        loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule),
      },
      {
        path: 'notification',
        loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule),
      },
      {
        path: 'widget-shells',
        loadChildren: () => import('./widget-shells/widget-shells.module').then(m => m.WidgetShellsModule),
      }
    ]
  },
  {
    path: 'simulator-management',
    component: PostLoginSimBookLayoutComponent,
    canActivateChild: [AuthGuard, SimulatorBookingAuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: SimbookDashboardComponent },
      {
        path: 'simulator-booking',
        loadChildren: () => import('./simulator-booking/simulator-booking-routing.module').then(m => m.SimulatorBookingRoutingModule),
        canActivate: [SimulatorBookingAuthGuard],
      }
    ]
  },
  {
    path: 'booking-widget',
    component: BookingWidgetComponent
  },
  {
    path: 'booking-membership-widget',
    component: BookingMembershipWidgetComponent
  },
  {
    path: 'membership-customer-widget',
    component: MembershipCustomerWidgetComponent
  },
  {
    path: 'digital-waiver-widget',
    component: DigitalWaiverWidgetComponent
  },
  {
    path: 'registration-widget',
    component: RegistrationWidgetComponent
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'payment-success-failure',
    component: PaymentSuccessFailureComponent
  },
  {
    path: '**', redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
